import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71613f22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-card" }
const _hoisted_2 = { class: "image-card-photo" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "image-card-footer" }

import { computed } from 'vue'
import { vFocal, Focal } from '../vFocal'


export default /*#__PURE__*/_defineComponent({
  __name: 'MatchingImageCard',
  props: {
    src: {},
    focal: {},
    relationship: {},
    alt: {},
    highlightRelationship: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



// relationship path from the root person: F (father) = blue square, M (mother) = pink square
const stepsRef = computed(() =>
  [...(props.relationship || '')].map(step => (step === 'F' ? 'f' : 'm')))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("img", {
        src: _ctx.src,
        alt: _ctx.alt
      }, null, 8, _hoisted_3), [
        [_unref(vFocal), _ctx.focal]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["rel-key", { 'rel-key-highlight': _ctx.highlightRelationship }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepsRef.value, (step, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: i,
            class: _normalizeClass(["rel-square", step])
          }, null, 2))
        }), 128))
      ], 2)
    ])
  ]))
}
}

})